export function mongoTextSearch(str: string) {
  return str
    .split(" ")
    .map((v) => `"${v}"`)
    .join(" ");
}
